// App.jsx or App.js
import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import icon from "../Icon1.png";
import Drilldown from "highcharts/modules/drilldown";

// Initialize drilldown module
Drilldown(Highcharts);

const options = {
  chart: {
    type: "column",
    height: 100,
    backgroundColor: "transparent",
    spacing: [0, 0, 0, 0],
  },
  title: { text: null },
  xAxis: {
    categories: [
      "Category A",
      "Category B",
      "Category C",
      "Category D",
      "Category E",
      "Category F",
    ],
    lineWidth: 2,
    lineColor: "#D6D6D6",
    labels: { enabled: false },
    tickLength: 0,
    gridLineWidth: 0,
  },
  yAxis: { visible: false },
  legend: { enabled: false },
  plotOptions: {
    series: {
      borderWidth: 0,
      dataLabels: { enabled: false },
      color: "#155E9C",
    },
  },
  tooltip: {
    enabled: true,
    zIndex: 200,
  },
  exporting: { enabled: false },
  credits: { enabled: false },

  series: [
    {
      name: "Main Categories",
      data: [
        {
          name: "Category A",
          y: 10,
          drilldown: "category-a",
          color: "#D6D6D6",
        },
        {
          name: "Category B",
          y: 20,
          drilldown: "category-b",
          color: "#155E9C",
        },
        {
          name: "Category C",
          y: 15,
          drilldown: "category-c",
          color: "#D6D6D6",
        },
        { name: "Category D", y: 5, drilldown: "category-d", color: "#D6D6D6" },
        { name: "Category E", y: 8, drilldown: "category-e", color: "#D6D6D6" },
        {
          name: "Category F",
          y: 12,
          drilldown: "category-f",
          color: "#D6D6D6",
        },
        {
          name: "Category G",
          y: 12,
          drilldown: "category-f",
          color: "#D6D6D6",
        },
        {
          name: "Category H",
          y: 12,
          drilldown: "category-f",
          color: "#D6D6D6",
        },
        {
          name: "Category I",
          y: 12,
          drilldown: "category-f",
          color: "#D6D6D6",
        },
      ],
    },
  ],

  drilldown: {
    series: [
      {
        id: "category-a",
        data: [
          ["Sub A1", 4],
          ["Sub A2", 6],
        ],
      },
      {
        id: "category-b",
        data: [
          ["Sub B1", 10],
          ["Sub B2", 10],
        ],
      },
      {
        id: "category-c",
        data: [
          ["Sub C1", 9],
          ["Sub C2", 6],
        ],
      },
      {
        id: "category-d",
        data: [
          ["Sub D1", 3],
          ["Sub D2", 2],
        ],
      },
      {
        id: "category-e",
        data: [
          ["Sub E1", 5],
          ["Sub E2", 3],
        ],
      },
      {
        id: "category-f",
        data: [
          ["Sub F1", 7],
          ["Sub F2", 5],
        ],
      },
    ],
  },
};
const chartData = {
  "% of Medicare": [
    { name: "Hospital A", y: 35 },
    { name: "Hospital B", y: 70 },
    { name: "Hospital C", y: 65 },
    { name: "Hospital A", y: 34 },
    { name: "Hospital B", y: 70 },
    { name: "Hospital C", y: 65 },
  ],
  "% Discount": [
    { name: "Hospital A", y: 30 },
    { name: "Hospital B", y: 0 },
    { name: "Hospital C", y: 35 },
    { name: "Hospital A", y: 30 },
    { name: "Hospital B", y: 0 },
    { name: "Hospital C", y: 35 },
  ],
  Completeness: [
    { name: "Network X", y: 230 },
    { name: "Network Y", y: 85 },
    { name: "Network Z", y: 92 },
    { name: "Hospital A", y: 30 },
    { name: "Hospital B", y: 0 },
    { name: "Hospital C", y: 35 },
  ],
};
const pieOptions = {
  chart: {
    type: "pie",
    backgroundColor: "transparent",
    height: 100,
    width: 100,
  },
  title: {
    text: null,
  },
  tooltip: {
    pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
  },
  plotOptions: {
    pie: {
      states: {
        hover: {
          enabled: false,
        },
        inactive: {
          opacity: 1,
        },
        halo: {
          opacity: 1,
        },
        select: {
          enabled: false,
          halo: {
            opacity: 1,
          },
        },
      },
      allowPointSelect: true,
      cursor: "pointer",
      dataLabels: {
        enabled: false,
      },
      showInLegend: false,
    },
  },
  exporting: { enabled: false },
  credits: { enabled: false },
  series: [
    {
      name: "Share",
      colorByPoint: true,
      data: [
        { name: "Used", y: 75, color: "#155E9C" },
        { name: "Remaining", y: 25, color: "lightgrey" },
      ],
    },
  ],
};
const DropdownSelectors = () => {
  const [selectedState, setSelectedState] = useState("California");
  const [selectedCarrier, setSelectedCarrier] = useState("Non-BUCA’s");
  const [activeTab, setActiveTab] = useState("% of Medicare");
  const states = ["California", "New York", "Texas", "Florida"];
  const carriers = ["BUCAs", "Non-BUCAs", "All"];
  const tabs = ["% of Medicare", "% Discount", "Completeness"];
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "left",
        gap: "13px",
      }}
    >
      <div
        className="d-flex flex-row"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyItems: "center",
          gap: "15px",
        }}
      >
        <div className="dropdown">
          <button
            className="btn"
            type="button"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{
              fontWeight: 600,
              fontSize: "16px",
              border: ".6px solid #d6d6d6",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              borderRadius: "7px",
              padding: "10px",
              width: "370px",
              height: "58px",
            }}
          >
            <div
              style={{
                fontWeight: 600,

                color: "#555",
                marginBottom: "5px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p
                className="mb-0"
                style={{ fontSize: "11px", marginBottom: "7px !important" }}
              >
                STATE SELECTION
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#555"
                className="bi bi-chevron-down"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1.646 5.646a.5.5 0 0 1 .708 0L8 11.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 
                6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>
            <span
              className="badge text-white"
              style={{
                backgroundColor: "#75738C",
                fontSize: "12px",
                width: "fit-content",
              }}
            >
              {selectedState}
            </span>
          </button>
          <ul
            className="dropdown-menu"
            aria-labelledby="dropdownMenuButton"
            style={{ width: "370px" }}
          >
            {states.map((state) => (
              <li key={state}>
                <button
                  className="dropdown-item"
                  onClick={() => setSelectedState(state)}
                >
                  {state}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Carrier Dropdown */}
        <div className="dropdown">
          <button
            className="btn"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{
              fontWeight: 600,
              fontSize: "16px",
              border: ".6px solid #d6d6d6",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              borderRadius: "7px",
              padding: "10px",
              // width: "280px",
              width: "370px",
              height: "58px",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                color: "#555",
                marginBottom: "7px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p className="mb-0" style={{ fontSize: "11px " }}>
                CARRIER SELECTION
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#555"
                className="bi bi-chevron-down"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1.646 5.646a.5.5 0 0 1 .708 0L8 11.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 
                6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>
            <span
              className="badge text-white"
              style={{
                backgroundColor: "#75738C",
                fontSize: "12px",
                width: "fit-content",
              }}
            >
              {selectedCarrier}
            </span>
          </button>
          <ul
            className="dropdown-menu"
            aria-labelledby="dropdownMenuButton1"
            style={{ width: "370px " }}
          >
            {carriers.map((carrier) => (
              <li key={carrier}>
                <button
                  className="dropdown-item"
                  onClick={() => setSelectedCarrier(carrier)}
                >
                  {carrier}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <hr style={{ margin: "0px", color: "#C2C2C2" }}></hr>
      <div style={{ display: "flex", gap: "20px" }}>
        <div style={{ width: "32%" }}>
          <div
            className="card bg-light text-center"
            style={{
              height: "160px",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "left",

              border: "none",
              display: "flex",
              // alignItems: "center",
              border: ".6px Solid #D6D6D6",
              // boxShadow:
              //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              display: "flex",
            }}
          >
            <div
              className="card text-center"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "left",
                alignItems: "center",
                // height: "175px",
                padding: " 5px 20px",

                // backgroundColor: "#F4FAFF ",
                border: "none",
                display: "flex",

                // boxShadow:
                //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  width: "100%",
                }}
              >
                <div className="d-flex flex-row justify-content-between align-items-center w-100">
                  <p
                    className="m-0"
                    style={{
                      fontSize: "13px",
                      color: "#333333",
                      margin: "0px !important",
                      width: "100%",
                      textAlign: "left",
                      fontWeight: "600",
                    }}
                  >
                    Overall Data Completeness
                  </p>
                  <p className="m-0">
                    <b style={{ color: "#3B3A3A" }}>93.16%</b>
                  </p>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    height: "26px",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  {tabs.map((tab) => (
                    <div
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      style={{
                        width: "100px",

                        borderRadius: "5px",
                        backgroundColor:
                          activeTab === tab ? "#F4FAFF" : "white",
                        color: activeTab === tab ? "#155E9C" : "#4E4E4E",
                        fontWeight: "600",
                        fontSize: "12px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border:
                          activeTab === tab ? "none" : ".2px Solid  #D5D5D5",
                      }}
                    >
                      {tab}
                    </div>
                  ))}
                </div>
              </div>

              <div
                style={{
                  marginTop: "10px",
                  width: "100%", // full width
                  maxWidth: "700px", // bigger size for laptops and desktops
                  // minWidth: "330px", // minimum size for smaller screens
                  margin: "0 auto", // center the chart
                }}
              >
                <HighchartsReact
                  highcharts={Highcharts}
                  options={{
                    chart: {
                      type: "column",
                      height: 70,
                      backgroundColor: "transparent",
                      spacing: [0, 0, 0, 0], // [top, right, bottom, left] padding
                    },
                    title: { text: null },
                    xAxis: {
                      categories: [
                        "Category A",
                        "Category B",
                        "Category C",
                        "Category D",
                        "Category E",
                        "Category F",
                      ],

                      lineWidth: 2, // thickness of the x-axis line
                      lineColor: "#D6D6D6", // color of the x-axis line
                      labels: {
                        enabled: false,
                        rotation: 0,
                      },
                      tickLength: 0,
                      gridLineWidth: 0,
                    },
                    yAxis: { visible: false },
                    legend: { enabled: false },
                    plotOptions: {
                      series: {
                        borderWidth: 0,
                        dataLabels: { enabled: false },
                        // color: "#155E9C",
                      },
                    },
                    tooltip: { enabled: true, zIndex: 200 },
                    exporting: { enabled: false },
                    series: [
                      {
                        name: "Sample",
                        data: [
                          { y: 5, color: "#D6D6D6" },
                          { y: 10, color: "#D6D6D6" },
                          { y: 8, color: "#D6D6D6" },
                          { y: 6, color: "#D6D6D6" },
                          { y: 12, color: "#155E9C" }, // 5th bar
                          { y: 7, color: "#D6D6D6" },
                        ],
                      },
                    ],
                    // series: [
                    //   {
                    //     name: activeTab,
                    //     // data: chartData[activeTab],
                    //     data: chartData[activeTab].map((value, index) => ({
                    //       y: value,
                    //       color: index === 4 ? "#155E9C" : "#D6D6D6", // Blue for 5th bar, grey for others
                    //     })),
                    //   },
                    // ],
                    credits: { enabled: false },
                  }}
                  key={activeTab}
                />
              </div>
            </div>
          </div>
        </div>
        <div style={{ width: "32%" }}>
          <div
            className="card bg-light text-center"
            style={{
              height: "160px",
              display: "flex",
              flexDirection: "row",
              // flexWrap: "wrap",
              justifyContent: "space-between",

              backgroundColor: "#F4FAFF ",
              border: ".6px solid #f4f4f4",
              display: "flex",
              // alignItems: "center",
              // boxShadow:
              //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              display: "flex",
            }}
          >
            <div
              className="card text-center"
              style={{
                display: "flex",
                flexDirection: "column",

                justifyContent: "space-between",
                alignItems: "center",
                // height: "175px",
                padding: " 10px 20px",
                alignContent: "center",
                backgroundColor: "#F4FAFF ",
                border: "none",
                display: "flex",

                // boxShadow:
                //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <div className="d-flex flex-row justify-content-between w-100">
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#333333",
                      // color: "red",
                      margin: "0px",
                      width: "100%",
                      textAlign: "left",
                      height: "25px !important",
                      fontWeight: "600",
                    }}
                  >
                    Network Summary
                  </p>
                  <p
                    className="m-0"
                    style={{
                      color: "#20486C",
                      background: "#FFFFFF",
                      fontSize: "12px",
                      padding: "5px 10px",
                      border: "none",
                      borderRadius: "5px",
                      fontWeight: "500",
                    }}
                  >
                    Drilldown
                  </p>
                </div>
              </div>

              <div
                style={{
                  // background: "yellow",
                  marginTop: "10px",
                  // width: "100%", // full width
                  maxWidth: "700px", // bigger size for laptops and desktops
                  minWidth: "300px", // minimum size for smaller screens
                  margin: "0 auto", // center the chart
                }}
              >
                <HighchartsReact highcharts={Highcharts} options={options} />
              </div>
            </div>
          </div>
        </div>
        <div
          className="card text-center"
          style={{
            display: "flex",
            height: "160px",
            width: "-webkit-fill-available",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "stretch",
            // height: "70%",
            padding: "10px 20px",
            // backgroundColor: "#F4FAFF ",
            border: ".6px Solid #D6D6D6",
            // boxShadow:
            //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
            display: "flex",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div>
              <img src={icon}></img>
            </div>
            <div
              className="card-body"
              style={{
                padding: "10px",

                border: "none",
                borderRadius: "7px",
                textAlign: "left",
              }}
            >
              <h5
                style={{
                  fontSize: "13px",
                  color: "#4E4E4E",
                  fontWeight: "600",
                }}
              >
                MRF Record Count
              </h5>
              <p className="card-text display-11">
                <b style={{ color: "#20486C" }}>11,809M</b>
              </p>
            </div>
            <div>
              {" "}
              <HighchartsReact highcharts={Highcharts} options={pieOptions} />
            </div>
          </div>

          <p
            className="w-100 "
            style={{
              textAlign: "left",
              color: "#4E4E4E",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            Deerhold covers 78% of the Record counts.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DropdownSelectors;
